export const projects = [
    {
        "name": "HAIL: Multimodal Journey Planner (Ford)",
        "keywords": [
            "Python",
            "Java",
            "Elasticsearch",
            "Cosmos DB",
            "Microsoft SQL Server",
        ],
        "description": "Multimodal journey planner (MMJP) allows passengers to find the best solution for each trip, with the assurance of being guided to their destination."
    },
    {
        "name": "IoT Engine",
        "keywords": [
            "Python",
            "Apache Kafka",
            "Apache Spark",
        ],
        "description": "IoT Engine will monitor the sensor device process and send an alert every time a problem occurs during this process. Monitoring systems and sensors will help with solving these problems and to make data-informed decisions and take corrective actions to avoid damaging.  The use of sensors will greatly improve the quality and speed of the production process, the same IoT engine will read sensor metrics data and update it into the monitoring system within a short span of time."
    },
    {
        "name": "Versa Titan  (SD-WAN)",
        "keywords": [
            "Python",
            "MongoDB",
            "Apache Kafka"
        ],
        "description": "Versa Titan is a Cloud Managed SD-WAN & SD-Security solution that provides IT with cloud-agility, simplifying the design, deployment, and operations of WAN. Developing a Network Device with software to control the entire branch network LAN, WAN, Enable security and monitoring."
    },
    {
        "name": "Honeycomb",
        "keywords": [
            "React",
            "Lumen",
            "MySQL"
        ],
        "description": "Honeycomb is to develop a mobile application that acts as a secured platform for money transactions between the app users. Users can add money to their wallet, and use it for their transactions. The app will be supporting English and Arabic language."
    },
    {
        "name": "JCB Smart App",
        "keywords": [
            "Laravel",
            "AngularJS",
            "MySQL "
        ],
        "description": "JCB India intends to use Smart Phone apps as an effective tool for their BHL Machine. Dealers/Sales and Marketing team will be using the JCB App to Diagnose and Demonstrate their offerings."
    }
]